<template>
  <section class="live-status btn-group btn-group-sm">
    <button class="btn btn-secondary" disabled>
      <span class="badge badge-pill badge-light mb-0">
        {{ room.status ? room.status : "서버 대기중" }}
      </span>
    </button>
    <button class="btn btn-secondary" v-if="room.startedAt" disabled>
      <span class="badge badge-pill badge-light mb-0">
        시작: {{ startedAt }}
      </span>
    </button>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
// import l from '@/vendor/logger'

export default {
  name: 'RoomsItemStatus',

  props: {
    room: Object,
    mode: String
  },

  computed: {
    ...mapGetters('rooms', [
      'formattedStartedAt'
    ]),
    startedAt () {
      return this.formattedStartedAt(`${this.mode}Rooms`)(this.room.id)
    }
  }
}
</script>

<style scoped>
</style>
